exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-32a577d8] {\n  max-width: 250px;\n}\n.img--rounded[data-v-32a577d8] {\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 4px;\n}\n", ""]);

// exports
